const BalanceDropdown = ({
  exposure,
  withdrawableBalance,
  mainBalance,
}: {
  exposure: string;
  withdrawableBalance: string;
  mainBalance: string;
}) => {
  return (
    <div className="w-[220px] bg-primary rounded-md text-black py-2 text-[11px] font-medium shadow-md">
      <div className="space-y-1 px-3">
        <Row label="Main Balance :" value={String(mainBalance ?? 0)} />
        <Row label="Withdrawable :" value={String(withdrawableBalance)} />
        <Row label="Exposure :" value={String(exposure ?? 0)} />
      </div>
    </div>
  );
};

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between">
      <span>{label}</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}

export default BalanceDropdown;
